'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _reactColor = require('react-color');

var _semanticUiReact = require('semantic-ui-react');

var _components = require('components');

var _reactVisjsTimeline = require('react-visjs-timeline');

var _reactVisjsTimeline2 = _interopRequireDefault(_reactVisjsTimeline);

require('./TimelineChart.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./TimelineChart.scss');

var TimelineChart = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    primary_color: state.templateData.primary_color,
    secondary_color: state.templateData.secondary_color,
    info_block: state.templateData.info_block,
    show_timeline_editor: state.templateData.show_timeline_editor
  };
}, {
  showTimelineEditor: templateActions.showTimelineEditor,
  updateTimelineData: templateActions.updateField
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TimelineChart, _Component);

  function TimelineChart(props) {
    (0, _classCallCheck3.default)(this, TimelineChart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TimelineChart.__proto__ || (0, _getPrototypeOf2.default)(TimelineChart)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      dateRangeArray: false,
      timelineEditorVisible: false
    };
    return _this;
  }

  (0, _createClass3.default)(TimelineChart, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {

      var elements = document.getElementsByClassName('vis-minor');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.backgroundColor = this.props.primary_color;
      }
      var elements = document.querySelectorAll('.vis-time-axis.vis-foreground');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.backgroundColor = this.props.primary_color;
      }
      var elements = document.querySelectorAll('.box-elements .vis-line');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.borderColor = this.props.primary_color;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var elements = document.getElementsByClassName('vis-minor');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.backgroundColor = this.props.primary_color;
      }

      var elements = document.querySelectorAll('.vis-time-axis.vis-foreground');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.backgroundColor = this.props.primary_color;
      }

      var elements = document.querySelectorAll('.box-elements .vis-line');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.borderColor = this.props.primary_color;
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var data;
      var info_block = this.props.info_block[this.props.data_parent];
      if (this.isJson(info_block[this.props.data_id]['title'])) {
        data = info_block[this.props.data_id]['title'] === '' ? false : JSON.parse(info_block[this.props.data_id]['title']);
        if (data) {
          if (data[0].start && data[0].end) {
            this.setState({ dateRangeArray: data });
          }
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      if (nextProps.show_timeline_editor != this.props.show_timeline_editor) {
        this.setState({ timelineEditorVisible: nextProps.show_timeline_editor });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          timelineEditorVisible = _state.timelineEditorVisible,
          chart_type = _state.chart_type;
      var _props = this.props,
          dataSectionStyleClass = _props.dataSectionStyleClass,
          info_block = _props.info_block,
          data_parent = _props.data_parent,
          data_id = _props.data_id,
          data_type = _props.data_type,
          primary_color = _props.primary_color,
          secondary_color = _props.secondary_color;

      var data = info_block[data_parent][data_id][data_type] === '' ? false : JSON.parse(info_block[data_parent][data_id]['chart_data']);

      return _react2.default.createElement(
        'div',
        { className: 'timelineWrapper ' + dataSectionStyleClass },
        _react2.default.createElement(
          'div',
          { className: 'hideChartIcon' },
          _react2.default.createElement(
            'div',
            { className: 'singleIcon' },
            _react2.default.createElement(_semanticUiReact.Icon, { onClick: this.openEditor, name: 'edit' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: '' },
          data && this.renderTimeline(data, primary_color, secondary_color)
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { closeIcon: true, style: { top: '10px' }, onClose: this.handleClose, open: this.state.timelineEditorVisible },
          _react2.default.createElement(_components.TimelineEditor, {
            data_parent: this.props.data_parent,
            data_id: this.props.data_id,
            data_type: this.props.data_type
          })
        )
      );
    }
  }]);
  return TimelineChart;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.rangeChangedHandler = function (props) {
    var _props2 = _this2.props,
        info_block = _props2.info_block,
        data_parent = _props2.data_parent,
        data_id = _props2.data_id;

    var newDateArray = [{ start: props.start, end: props.end }];
    _this2.setState({ dateRangeArray: newDateArray });
    var newDateArrayString = (0, _stringify2.default)(newDateArray);
    _this2.props.updateTimelineData(newDateArrayString, data_id, 'title', data_parent);
  };

  this.isJson = function (str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  this.hexToRgbA = function (hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [c >> 16 & 255, c >> 8 & 255, c & 255].join(',') + ',0.1)';
    }
    throw new Error('Bad Hex');
  };

  this.openEditor = function () {
    _this2.setState({ timelineEditorVisible: true });
  };

  this.renderTimeline = function (data, primary_color, secondary_color) {
    var options = {
      width: '19cm',
      stack: true,
      showMajorLabels: false,
      showCurrentTime: true,
      zoomMin: 1000000,
      format: {
        minorLabels: {
          month: 'MMM',
          year: 'YYYY'
        }
      },
      editable: {
        updateTime: true
      },
      selectable: true
    };

    var groups = [{
      id: 2,
      content: 'A',
      className: 'period-elements'
    }, {
      id: 1,
      content: 'B',
      className: 'box-elements'
    }];

    var extraOptions;
    if (_this2.state.dateRangeArray) {

      extraOptions = (0, _extends3.default)({}, options, {
        start: _this2.state.dateRangeArray[0].start,
        end: _this2.state.dateRangeArray[0].end
      });
    } else {
      extraOptions = (0, _extends3.default)({}, options);
    }

    var primary_color_transparent = _this2.hexToRgbA(primary_color);

    data.map(function (item, index) {
      if (item['is_period'] && item['end']) {
        item['type'] = 'background';
        item['group'] = 2;
        item['style'] = 'color:' + primary_color + ';background-color:' + primary_color_transparent + ';height:100%;text-align:center;border-left:1px solid ' + primary_color + ';border-right:1px solid ' + primary_color + ';border-top:1px solid ' + primary_color + ';font-size:10px';
      } else {
        item['type'] = 'box';
        item['group'] = 1;
        item['style'] = 'color:' + primary_color + ';border:1px solid ' + primary_color + ';text-align:justify;max-width:300px;white-space:pre-wrap;font-size:10px;background:none;';
      }
    });

    return _react2.default.createElement(_reactVisjsTimeline2.default, { rangechangedHandler: function rangechangedHandler(props) {
        return _this2.rangeChangedHandler(props);
      }, groups: groups, options: extraOptions, items: data, margin: { top: 40 } });
  };

  this.handleClose = function () {

    _this2.setState({ timelineEditorVisible: false });
    _this2.props.showTimelineEditor(false);
  };
}, _temp)) || _class);
exports.default = TimelineChart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TimelineChart/TimelineChart.js
// module id = 1752
// module chunks = 0